var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22222 20H17.7778C19.0051 20 20 19.0051 20 17.7778V2.22222C20 0.994923 19.0051 0 17.7778 0H2.22222C0.994923 0 0 0.994923 0 2.22222V17.7778C0 19.0051 0.994923 20 2.22222 20Z",
    fill: "#007EBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2218 17.2218H14.2539V12.1668C14.2539 10.7809 13.7273 10.0064 12.6303 10.0064C11.437 10.0064 10.8135 10.8124 10.8135 12.1668V17.2218H7.95327V7.59216H10.8135V8.88927C10.8135 8.88927 11.6735 7.29796 13.7169 7.29796C15.7595 7.29796 17.2218 8.54525 17.2218 11.1249V17.2218ZM4.54105 6.33124C3.5668 6.33124 2.77734 5.53558 2.77734 4.55429C2.77734 3.573 3.5668 2.77734 4.54105 2.77734C5.5153 2.77734 6.30429 3.573 6.30429 4.55429C6.30429 5.53558 5.5153 6.33124 4.54105 6.33124ZM3.06416 17.2218H6.04662V7.59216H3.06416V17.2218Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.56b768880c3a728f2f2bc2329b38836f.svg";
export { ForwardRef as ReactComponent };